import { render, staticRenderFns } from "./CustomerBillingDetails.vue?vue&type=template&id=6cf8848a&"
import script from "./CustomerBillingDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerBillingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports